import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export interface SpinnerEvent {
    shouldShow: boolean;
    threshold?: number;
}

@Injectable({
    providedIn: 'root'
})
export class LoadingController {

    spinnerObservor = new Subject<SpinnerEvent>();

    constructor() {}

    show(threshold?: number) {
        this.spinnerObservor.next({
            shouldShow: true,
            threshold
        });
    }

    hide() {
        this.spinnerObservor.next({
            shouldShow: false
        });
    }

}
